module.exports = __webpack_public_path__ + "img/letter_w_icon_151238.f093fad4.svg";